import { types } from 'mobx-state-tree';

import mandatoryId from 'utils/store/mandatoryId';
import { createArrayWithTransform } from 'utils/store/createArray';

export const ModuleTagModel = types.model('ModuleTagModel', {
  id: types.identifierNumber,
  name: types.maybe(types.string),
  module_prompt: types.maybe(types.string)
});

export const createModuleTagModel = (data?: any): ModuleTagModelType => {
  return ModuleTagModel.create({
    id: mandatoryId(data?.id),
    name: data?.name || undefined,
    module_prompt: data?.module_prompt || undefined
  });
};

export type ModuleTagModelType = typeof ModuleTagModel.Type;

export const StrategySettingModel = types.model('StrategySettingModel', {
  id: types.identifierNumber,
  strategy_type: types.maybe(types.string)
});

export const createStrategySettingModel = (
  data?: any
): StrategySettingModelType => {
  return StrategySettingModel.create({
    id: mandatoryId(data?.id),
    strategy_type: data?.strategy_type || undefined
  });
};

export type StrategySettingModelType = typeof StrategySettingModel.Type;

export const AiModuleModel = types.model('AiModuleModel', {
  id: types.identifierNumber,
  name: types.maybe(types.string),
  module_prompt: types.maybe(types.string),
  intro_text: types.maybe(types.string),
  icon_url: types.maybe(types.string),
  module_tags: types.array(ModuleTagModel),
  strategy_settings: types.array(StrategySettingModel)
});

export const createAiModuleModel = (data?: any): AiModuleModelType => {
  return AiModuleModel.create({
    id: mandatoryId(data?.id),
    name: data?.name || undefined,
    module_prompt: data?.module_prompt || undefined,
    intro_text: data?.intro_text || undefined,
    icon_url: data?.icon_url || undefined,
    module_tags: createArrayWithTransform(data?.module_tags, createModuleTagModel),
    strategy_settings: createArrayWithTransform(data?.strategy_settings, createStrategySettingModel)
  });
};

export type AiModuleModelType = typeof AiModuleModel.Type;
export default AiModuleModel;
